import React, { lazy, useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import './assets/css/styles.css';
import FullPageLoader from './components/loaders/FullPageLoader';
import ErrorFallback from './Error/ErrorBoundary/ErrorFallback';
import errorHandler from './Error/ErrorBoundary/errorHandler';
import { withSuspense } from './hoc/withSuspense';

const ProjectRoutes = withSuspense(
  lazy(() => import(/* webpackChunkName: "routes" */ './routes/ProjectRoutes')),
  <FullPageLoader />
);

const App = () => {
  // console.log(window.innerWidth, 'a');

  useEffect(() => {
    // Disable logs in production
    // eslint-disable-next-line no-undef
    if (process.env.NODE_ENV !== 'development') {
      let noOp = function () { }; // no-op function
      if (!window.console) {
        // eslint-disable-next-line no-global-assign
        console = {
          log: noOp,
          warn: noOp,
          error: noOp,
        };
      } else {
        // eslint-disable-next-line no-global-assign
        console = {
          ...console,
          log: noOp,
          warn: noOp,
          error: noOp,
        };
      }
    }
  }, []);

  return (
    <>
      <ErrorBoundary FallbackComponent={ErrorFallback} onError={errorHandler}>
        <ProjectRoutes />
        <ToastContainer
          theme="dark"
          toastStyle={{ backgroundColor: '#222222', color: '#fff' }}
          position="bottom-left"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </ErrorBoundary>
    </>
  );
}

export default App;
